import { Icon, IconProps } from '@chakra-ui/react';

export const GoogleIcon: React.FC<IconProps> = (props) => (
  <Icon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M9.89481 8.18178V12.0545H15.2201C14.9863 13.3 14.2845 14.3545 13.2321 15.0636L16.4434 17.5818C18.3145 15.8364 19.3939 13.2728 19.3939 10.2273C19.3939 9.51825 19.331 8.83637 19.214 8.18189L9.89481 8.18178Z"
      fill="#1A202C"
    />
    <path
      d="M4.34934 11.9034L3.62506 12.4637L1.06132 14.4818C2.68949 17.7454 6.02655 20 9.89455 20C12.5661 20 14.806 19.1091 16.4432 17.5819L13.2318 15.0636C12.3503 15.6636 11.2258 16.0273 9.89455 16.0273C7.32187 16.0273 5.13605 14.2728 4.35339 11.9091L4.34934 11.9034Z"
      fill="#1A202C"
    />
    <path
      d="M1.06138 5.51819C0.386763 6.86359 0 8.38179 0 9.99995C0 11.6181 0.3867 13.1364 1.06132 14.4818C1.06132 14.4908 4.35377 11.8999 4.35377 11.8999C4.15587 11.2999 4.0389 10.6636 4.0389 9.99984C4.0389 9.33612 4.15587 8.6998 4.35377 8.0998L1.06138 5.51819Z"
      fill="#1A202C"
    />
    <path
      d="M9.89476 3.98181C11.352 3.98181 12.6474 4.49089 13.6818 5.47272L16.5154 2.60912C14.7972 0.99097 12.5664 0 9.89476 0C6.02675 0 2.68955 2.24546 1.06138 5.51819L4.3536 8.1C5.13616 5.73634 7.32208 3.98181 9.89476 3.98181Z"
      fill="#1A202C"
    />
  </Icon>
);
